// extracted by mini-css-extract-plugin
export default {"gallery_wrapper":"UserGallery_gallery_wrapper__vxjB8","gallery_wrapper__image":"UserGallery_gallery_wrapper__image__6FzFe"};